module.exports = __webpack_public_path__ + "static/media/30.d8d183fc.wav";